'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppUser$FirebaseUser(firebase) {
  this.XJ = null;
  this.XJ = firebase;
}
export { $c_Lapp_data_AppUser$FirebaseUser as $c_Lapp_data_AppUser$FirebaseUser };
$p = $c_Lapp_data_AppUser$FirebaseUser.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppUser$FirebaseUser;
/** @constructor */
function $h_Lapp_data_AppUser$FirebaseUser() {
}
export { $h_Lapp_data_AppUser$FirebaseUser as $h_Lapp_data_AppUser$FirebaseUser };
$h_Lapp_data_AppUser$FirebaseUser.prototype = $p;
$p.n = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_Show$ShowInterpolator$().b5(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_StringContext($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().d(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.r().C)(["FirebaseUser(", ")"]))), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcats_Show$Shown.r().C)([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$Shown($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_Show$Shown$().aH(JSON.stringify(this.XJ, (void 0), 2), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_instances_package$string$().bi))])));
});
var $d_Lapp_data_AppUser$FirebaseUser = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppUser$FirebaseUser, "app.data.AppUser$FirebaseUser", ({
  Cx: 1
}));
export { $d_Lapp_data_AppUser$FirebaseUser as $d_Lapp_data_AppUser$FirebaseUser };
//# sourceMappingURL=app.data.-App-User$-Firebase-User.js.map
